import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_5407_154945"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={16}
      height={16}
    >
      <rect width={16} height={16} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_5407_154945)">
      <path
        d="M7.30033 10.3654L11.067 6.5987L10.117 5.6487L7.30033 8.46536L5.90033 7.06536L4.95033 8.01536L7.30033 10.3654ZM8.00033 14.6654C6.45588 14.2765 5.18088 13.3904 4.17533 12.007C3.16977 10.6237 2.66699 9.08759 2.66699 7.3987V3.33203L8.00033 1.33203L13.3337 3.33203V7.3987C13.3337 9.08759 12.8309 10.6237 11.8253 12.007C10.8198 13.3904 9.54477 14.2765 8.00033 14.6654Z"
        fill="url(#paint0_linear_5407_154945)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_5407_154945"
        x1={-0.399414}
        y1={1.59922}
        x2={13.6006}
        y2={16.7992}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.352732} stopColor="#9E63E7" />
        <stop offset={1} stopColor="#704C9C" />
      </linearGradient>
    </defs>
  </svg>
);
export default SVGComponent;
